import * as Immutable from 'immutable';

import type {AxiosResponse} from 'axios';
import type {ApiConfiguration} from 'middleware/api';
import type {CALL_EXTERNAL, CallAction} from 'middleware/external-calls';

export const createRequestAction = (action: CallAction, config: ApiConfiguration) => {
    const nextAction = Object.assign({}, action, {
        type: config.types[0],
        data: config.data,
    });
    return deleteObjectSymbols(nextAction);
};

export const createSuccessAction = (action: CallAction, config: ApiConfiguration, response: AxiosResponse) => {
    const nextAction = Object.assign({}, action, {
        type: config.types[1],
        data: response.data,
    });
    return deleteObjectSymbols(nextAction);
};

export const enforcePlainJSData = (data: unknown) => {
    if (Immutable.isImmutable(data)) {
        data = data.toJS();
    }
    return data;
};

type CallActionWithTypeAndData = CallAction & {
    type: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
};

const deleteObjectSymbols = (obj: CallActionWithTypeAndData): Omit<CallActionWithTypeAndData, typeof CALL_EXTERNAL> => {
    Object.getOwnPropertySymbols(obj).forEach((symbol) => {
        delete obj[symbol];
    });

    return obj;
};
